import script from "./newSelectPer.vue?vue&type=script&setup=true&lang=js"
export * from "./newSelectPer.vue?vue&type=script&setup=true&lang=js"

import "./newSelectPer.vue?vue&type=style&index=0&id=27b86888&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b86888"]])

export default __exports__